import { cornType } from '@eigtech/shared-corn';
export const meetingServiceCorn = (eventName) => cornType('meeting', eventName);
export const MeetingServiceCornSchema = meetingServiceCorn();
